import React, { Component } from 'react'
import { Card, Table } from 'react-bootstrap'

import { toJS } from 'mobx';
import { observer } from 'mobx-react';

import { InfoArrowBlackImg } from 'constants/Images';
import SolutionStore from '../../store/SolutionStore';
import NeedTypeEnum from 'constants/NeedTypeEnum';
import moment from 'moment'

import './new-policy-timeline-table.css'
import ProductConstants from 'constants/ProductConstants';
// import SolutionStore from "modules/solution/store/SolutionStore"


const NewPolicyTimlineTable = observer(class NewPolicyTimlineTable extends Component {
    constructor(props) {
        super(props);
        this.policyTimeLineRef = React.createRef();
    }

    fetchProductEndMessage = (productName) => {
        switch (productName) {
            case ProductConstants.EASY_PENSION:
            case ProductConstants.FOREVER_PENSION:
            case ProductConstants.SARAL_PENSION:
            case ProductConstants.FOREVER_PENSION_DEFERRED_ANNUITY:
            case ProductConstants.FOREVER_PENSION_IMMEDIATE_ANNUITY:
                return "continues till applicable Life Assured(s) is/are alive"

            default:
                return "plan ends"
        }
    }

    componentDidMount() {
        if (this.props.isKeypressScrollActive) {
            setTimeout(() => {
                this.policyTimeLineRef.current.focus();
            }, 200);
        }
    }

    componentDidUpdate() {
        if (this.props.isKeypressScrollActive) {
            setTimeout(() => {
                this.policyTimeLineRef.current.focus();
            }, 200);
        }
    }

    handlePolicyTableScroll = event => {
        this.policyTimeLineRef.current.focus();
    };

    render() {
        const list = this.props.data.policyTimeLineData
        const headerList = this.props.data.policyTimeLineData?.header_list
        return (
            <Card className='px-3 policy-timeline-table-card h-100' onScroll={this.handlePolicyTableScroll}>
                <Table className='w-100 policy-timeline-table mb-0 rounded' tabIndex={0} ref={this.policyTimeLineRef}>
                    <thead className='policy-timeline-header'>
                        <tr>
                            {headerList.map((item, index) =>
                                item === "Age" ? <td key={index} className='font-size-12 year-label font-weight-bold '>Age<br /> [{list?.primary_la_name}]</td> :
                                    item === "Sec_Age" ? <td key={index} className='font-size-12 year-label font-weight-bold '>Age<br /> [{list?.secondary_la_name}]</td> :
                                        item === "Life Cover" ? <td key={index} className='font-size-12 year-label font-weight-bold '>Life Cover<br /> [{list?.primary_la_name}]</td> :
                                            item === "Sec_Life_Cover" ? <td key={index} className='font-size-12 year-label font-weight-bold '>Life Cover<br /> [{list?.secondary_la_name}]</td> :
                                                <td key={index} className='font-size-12 year-label font-weight-bold '>{item}</td>
                            )
                            }
                        </tr>
                    </thead>
                    <tbody className='policy-timeline-table-body'>
                        {list?.primary_la_list.map((value, index) => {

                            return (
                                <>
                                    <tr key={index} className='table-row policy-timeline-table-row'>
                                        <td className='font-size-14 border border-dark'>
                                            {index + 1}
                                        </td>
                                        <td className='font-size-14 border border-dark'>
                                            {value.calender_year}
                                        </td>
                                        <td key={index} className={`laList font-size-14 text-primary ${index == list.primary_la_list.length - 1 ? 'policy-table-custom-border' : ""}`}>
                                            <div className={` ${index == list.primary_la_list.length - 1 ? '' : "policy-table-custom-border"}`}>
                                                {(value.la_age === 0 || !value.la_age) ? "" : value.la_age + " Yrs"}
                                            </div>
                                        </td>

                                        {list.secondary_la_list.length > 0 &&

                                            <td key={index} className={`laList font-size-14 text-primary ${index == list.primary_la_list.length - 1 ? 'policy-table-custom-border' : ""}`}>
                                                <div className={` ${index == list.primary_la_list.length - 1 ? '' : "policy-table-custom-border"}`}>
                                                    {(list.secondary_la_list[index].la_age === 0 || !list.secondary_la_list[index].la_age) ? "" : list.secondary_la_list[index].la_age + " Yrs"}
                                                </div>
                                            </td>
                                        }

                                        <td key={index} className={`laList font-size-14 text-primary ${index == list.primary_la_list.length - 1 ? 'policy-table-custom-border' : ""}`}>
                                            <div className={` ${index == list.primary_la_list.length - 1 ? '' : "policy-table-custom-border"}`}>
                                                {value.you_pay === 0 ? "" : global.toINR(value.you_pay, true)}
                                            </div>
                                        </td>
                                        {headerList.includes("You Get") &&
                                            <td key={index} className={`laList font-size-14 text-primary ${index == list.primary_la_list.length - 1 ? 'policy-table-custom-border' : ""}`}>
                                                <div className={` ${index == list.primary_la_list.length - 1 ? '' : "policy-table-custom-border"}`}>
                                                    {value.you_get === 0 ? "" : global.toINR(value.you_get, true)}
                                                </div>
                                            </td>
                                        }

                                        <td key={index} className={`laList font-size-14 text-primary ${index == list.primary_la_list.length - 1 ? 'policy-table-custom-border' : ""}`}>
                                            <div className={` ${index == list.primary_la_list.length - 1 ? '' : "policy-table-custom-border"}`}>
                                                {value.life_cover === 0 ? "" : global.toINR(value.life_cover, true)}
                                            </div>
                                        </td>
                                        {list.secondary_la_list.length > 0 &&

                                            <td key={index} className={`laList font-size-14 text-primary ${index == list.primary_la_list.length - 1 ? 'policy-table-custom-border' : ""}`}>
                                                <div className={` ${index == list.primary_la_list.length - 1 ? '' : "policy-table-custom-border"}`}>
                                                    {list.secondary_la_list[index].la_life_cover === 0 ? "" : global.toINR(list.secondary_la_list[index].la_life_cover, true)}
                                                </div>
                                            </td>
                                        }

                                    </tr>
                                    {list?.primary_la_list.length - 1 === index &&
                                        <tr className='table-row policy-timeline-table-row '>
                                            <td colSpan="8" className={`font-size-14 text-primary ${index == list.primary_la_list.length - 1 ? '' : ""}`}>
                                                <div className={`${index == list.primary_la_list.length - 1 ? '' : ""}`}>
                                                    {/* {value.productName.map((name, productIndex) => (name.totalYear - 1 === index && index === value.yearIndex) && (<div>{} {this.fetchProductEndMessage(name.productName)}</div>))} */}
                                                    <div>{list.product_name} {this.fetchProductEndMessage(list.product_name)}</div>
                                                </div>
                                            </td>
                                        </tr>}
                                </>
                            )
                        })}
                    </tbody>
                </Table >
                <p className='text-left my-3 font-size-14 text-secondary'>*This table excludes underwriting extra premium, frequency loadings on premiums and riders premium, if any.</p>
            </Card>
        );
    }
});

NewPolicyTimlineTable.defaultProp = {
    isKeypressScrollActive: false
}

export default NewPolicyTimlineTable;